import { FileLikeObject } from '@components/ActsAndDocumentsForm';

export const isFileLikeObject = (
  file: File | FileLikeObject,
): file is FileLikeObject => 'url' in file;
